import { mapValues } from 'lodash';
import { setIn } from 'icepick';
import * as registrationFieldPageType from '../../../utils/registrationFieldPageType';

const contactWidgetTypes = [
  'EventStandardContactFieldText',
  'EventStandardContactFieldAddress',
  'EventCustomContactFieldText',
  'EventCustomContactFieldDateTime',
  'EventCustomContactFieldSingleChoice',
  'EventCustomContactFieldMultiChoice'
];

/**
 * Version 4 migrations for the event website.
 * - Add registrationFieldPageType for contact widgets to registration if missing. All contact fields prior to
 * version 4 were registration contact fields. There are now cancellation contact fields.
 */
export default function v4(website) {
  return {
    ...website,
    eventVersion: 4,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (contactWidgetTypes.includes(layoutItem.widgetType) && !layoutItem.config.registrationFieldPageType) {
        return setIn(layoutItem, ['config', 'registrationFieldPageType'], registrationFieldPageType.Registration);
      }
      return layoutItem;
    })
  };
}
